import React from 'react';
import get from 'lodash/get';
import partial from 'lodash/partial';
import {Link} from 'react-router-dom';
import {FormattedMessage} from 'react-intl';
import PrizeBreakId from 'components/prizes/PrizeBreakId';
import PrizeStatus from 'components/prizes/PrizeStatus';
import PrizeActions from './PrizeActions';
import {canDeletePrize, formatDate, PrizeTypeMapping} from 'utils/DBUtils';

export default {
  Title: props => ({
    header: <FormattedMessage id='prizeList.column.header.title' />,
    fieldName: 'title',
    toolTip: prize => Boolean(prize.title),
    toolTipData: prize => prize.title,
    detailFunc: prize => {
      const content = prize.title || <FormattedMessage id='prizeList.column.tooltip.noTitle' />;
      return <Link to={`/prize/${prize.id}/edit?openSection=editPrizeSection`}>{content}</Link>;
    },
    canSort: true
  }),

  PublishStatus: props => ({
    header: <FormattedMessage id='prizeList.column.header.status' />,
    fieldName: 'publishStatus',
    detailFunc: prize => <PrizeStatus {...prize} />
  }),

  Points: props => ({
    header: <FormattedMessage id='prizeList.column.header.points' />,
    fieldName: 'costToEnter',
    detailFunc: prize => prize.costToEnter
  }),

  BreakId: props => ({
    header: <FormattedMessage id='prizeList.column.header.breakId' />,
    detailFunc: prize => (
      <PrizeBreakId
        prize={prize}
        onClick={props.openPrizeChallengesModal} />
    )
  }),

  Entries: props => ({
    header: <FormattedMessage id='prizeList.column.header.entries' />,
    fieldName: 'numberOfEntries',
    detailFunc: prize => {
        const count = prize.numberOfEntries || 0;
        const prizeType = PrizeTypeMapping[prize.type];

        return <Link to={`/entries/${prizeType}/${prize.id}`}>{count}</Link>
    },

    // cf. DBRKCP-9734
    canSort: false
  }),

  StartDate: props => ({
    header: <FormattedMessage id='prizeList.column.header.startDate' />,
    fieldName: 'startTime',
    detailFunc: prize => prize.startTime && formatDate(prize.startTime, props.prizeTableConfig.dateFormat),
    canSort: true
  }),

  EndDate: props => ({
    header: <FormattedMessage id='prizeList.column.header.endDate' />,
    fieldName: 'endTime',
    detailFunc: prize => prize.endTime && formatDate(prize.endTime, props.prizeTableConfig.dateFormat),
    canSort: true
  }),

  Winner: props => ({
    header: <FormattedMessage id='prizeList.column.header.winner' />,
    fieldName: 'winningEntries',
    detailFunc: prize => {
      const winningEntries = get(prize, 'winningEntries', []);

      if (winningEntries.length > 0) {
        if (winningEntries.length === 1) {
          const [winningEntry] = winningEntries;
          const content = [winningEntry.firstName, winningEntry.lastName].join(' ');

          const onClick = event => {
            event.preventDefault();
            props.openWinnerDetailModal(winningEntry.id);
          };

          return (
            <a
              href='#'
              onClick={onClick}
              className='winner-contact-link'>
              {content}
            </a>
          );
        } else {
          return (
            <Link to={`/prize/${prize.id}/winners`}>
              <FormattedMessage id='prizeList.column.content.winner.multiple' />
            </Link>
          );
        }
      }
    }
  }),

  Actions: props => ({
    header: <FormattedMessage id='prizeList.column.header.actions' />,
    detailFunc: prize => (
      <PrizeActions
        prizeCanBeDeleted={canDeletePrize(prize)}
        userCanDeletePrizes={props.userCanDeletePrizes}
        onCopyPrize={partial(props.showCopyPrizeModal, prize.id)}
        onDeletePrize={partial(props.showDeletePrizeConfirmation, prize)} />
    )
  })
};



// WEBPACK FOOTER //
// ./public/pages/ListPrizes/columns.jsx